const reducer = state => ({
  ...state,
  active: true,
  loading: true,
});

export default reducer;
